export var COOKIE_ACCESS_DELAY = 1000;
export function cacheCookieAccess(name) {
    var timeout;
    var cache;
    var hasCache = false;
    var cacheAccess = function () {
        hasCache = true;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function () {
            hasCache = false;
        }, COOKIE_ACCESS_DELAY);
    };
    return {
        get: function () {
            if (hasCache) {
                return cache;
            }
            cache = getCookie(name);
            cacheAccess();
            return cache;
        },
        set: function (value, expireDelay) {
            setCookie(name, value, expireDelay);
            cache = value;
            cacheAccess();
        },
    };
}
export function setCookie(name, value, expireDelay) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
export function getCookie(name) {
    var matches = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return matches ? matches.pop() : undefined;
}
export function areCookiesAuthorized() {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        var testCookieName = 'dd_rum_test';
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, 1000);
        return getCookie(testCookieName) === testCookieValue;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}
//# sourceMappingURL=cookie.js.map